<template>
  <b-form-group id="input-password" label="Senha" label-for="inputPassword">
    <b-input-group>
      <b-form-input
        id="password"
        :value="value"
        @input="getValue"
        :type="type"
        placeholder="Senha"
        :state="state"
        :class="noBorder ? 'no-border' : ''"
        required
      ></b-form-input>

      <b-input-group-append>
        <b-button @mousedown="passwordShow" @mouseup="passwordHide">
          <b-icon-eye-slash-fill class="b-icon-eye-slash"/>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-form-invalid-feedback :state="state">
      {{ validationMessage }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: "InputPassword",
  data() {
    return {
      password: "",
      type: "password"
    };
  },
  props: {
    value: String,
    validationMessage: String,
    noBorder: Boolean
  },
  computed: {
    state() {
          if (this.validationMessage == null)
                return null
                
          return !this.validationMessage
    }
  },
  methods: {
    //Ativa e desativa o visualizador de senha
    passwordShow() {
      this.type = "text";
    },
    passwordHide() {
      this.type = "password";
    },
    getValue(value) {
      this.$emit('input', value)
    }
  }
};
</script>

<style scoped>
.b-icon-eye-slash {
  transition: 0.1s;
}

.b-icon-eye-slash:hover {
  height: 1.1em;
  width: 1.1em;
}

div div button{
  position: relative !important;
  height: 31px !important;  
  width: 40px !important;
  left: -2px;
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #888b8d;
  border: none;
}

div div button:hover , div div button:active, div div button:focus{
  color: #888b8d !important;
  background-color: #fff !important;
  box-shadow: none !important;
}

</style>